export default [
    {
        "name": "Played First Game",
        "category": "Overall",
        "title": "Let the Games Begin",
        "description": "Played First Game",
        "image": "ace.png",
        "points": "15",
        "order": "1",
        "check": function (p) { return p["win"] > 0 || p["loss"] > 0 }
    },
    {
        "name": "5 Easy Wins",
        "category": "Easy",
        "title": "Piece of Cake",
        "description": "Win 5 matches on Easy",
        "image": "cake-slice.png",
        "points": "15",
        "order": "2",
        "check": function (p) { return p["win_Easy"] >= 5 }
    },
    {
        "name": "5 Medium Wins",
        "category": "Medium",
        "title": "Made Flight",
        "description": "Win 5 matches on Medium",
        "image": "butterfly.png",
        "points": "15",
        "order": "3",
        "check": function (p) { return p["win_Medium"] >= 5 }
    },
    {
        "name": "10 Medium Wins",
        "category": "Medium",
        "title": "Quick Flyer",
        "description": "Win 10 matches on Medium",
        "image": "dragonfly.png",
        "points": "15",
        "order": "4",
        "check": function (p) { return p["win_Medium"] >= 10 }
    },
    {
        "name": "20 Medium Wins",
        "category": "Medium",
        "title": "Growing Force",
        "description": "Win 20 matches on Medium",
        "image": "bee.png",
        "points": "15",
        "order": "5",
        "check": function (p) { return p["win_Medium"] >= 20 }
    },
    {
        "name": "30 Medium Wins",
        "category": "Medium",
        "title": "Little Fighter",
        "description": "Win 30 matches on Medium",
        "image": "wasp-sting.png",
        "points": "15",
        "order": "6",
        "check": function (p) { return p["win_Medium"] >= 30 }
    },
    {
        "name": "50 Medium Wins",
        "category": "Medium",
        "title": "Little Champion ",
        "description": "Win 50 matches on Medium",
        "image": "scarab-beetle.png",
        "points": "60",
        "order": "7",
        "check": function (p) { return p["win_Medium"] >= 50 }
    },
    {
        "name": "5 Hard Wins",
        "category": "Hard",
        "title": "Got Your Feet Wet",
        "description": "Win 5 matches on Hard",
        "image": "ammonite.png",
        "points": "15",
        "order": "9",
        "check": function (p) { return p["win_Hard"] >= 5 }
    },
    {
        "name": "10 Hard Wins",
        "category": "Hard",
        "title": "Neigh to Losing",
        "description": "Win 10 matches on Hard",
        "image": "horse-head.png",
        "points": "15",
        "order": "10",
        "check": function (p) { return p["win_Hard"] >= 10 }
    },
    {
        "name": "20 Hard Wins",
        "category": "Hard",
        "title": "Hard to Beat",
        "description": "Win 20 matches on Hard",
        "image": "turtle.png",
        "points": "15",
        "order": "11",
        "check": function (p) { return p["win_Hard"] >= 20 }
    },
    {
        "name": "30 Hard Wins",
        "category": "Hard",
        "title": "Fast And Silent",
        "description": "Win 30 matches on Hard",
        "image": "frog.png",
        "points": "15",
        "order": "12",
        "check": function (p) { return p["win_Hard"] >= 30 }
    },
    {
        "name": "50 Hard Wins",
        "category": "Hard",
        "title": "Choice Fish",
        "description": "Win 50 matches on Hard",
        "image": "angler-fish.png",
        "points": "50",
        "order": "13",
        "check": function (p) { return p["win_Hard"] >= 50 }
    },
    {
        "name": "5 Crazy Ninja Wins",
        "category": "CrazyNinja",
        "title": "Ninja Has Awaken",
        "description": "Win 5 matches on CrazyNinja",
        "image": "sleepy.png",
        "points": "30",
        "order": "14",
        "check": function (p) { return p["win_CrazyNinja"] >= 5 }
    },
    {
        "name": "10 Crazy Ninja Wins",
        "category": "CrazyNinja",
        "title": "Sparing Partner",
        "description": "Win 10 matches on CrazyNinja",
        "image": "ninja-mask.png",
        "points": "35",
        "order": "15",
        "check": function (p) { return p["win_CrazyNinja"] >= 10 }
    },
    {
        "name": "20 Crazy Ninja Wins",
        "category": "CrazyNinja",
        "title": "Black Belt",
        "description": "Win 20 matches on CrazyNinja",
        "image": "iron-mask.png",
        "points": "40",
        "order": "16",
        "check": function (p) { return p["win_CrazyNinja"] >= 20 }
    },
    {
        "name": "30 Crazy Ninja Wins",
        "category": "CrazyNinja",
        "title": "Merciless",
        "description": "Win 30 matches on CrazyNinja",
        "image": "tear-tracks.png",
        "points": "50",
        "order": "17",
        "check": function (p) { return p["win_CrazyNinja"] >= 30 }
    },
    {
        "name": "50 Crazy Ninja Wins",
        "category": "CrazyNinja",
        "title": "Ninja Destroyer",
        "description": "Win 50 matches on CrazyNinja",
        "image": "pummeled.png",
        "points": "70",
        "order": "18",
        "check": function (p) { return p["win_CrazyNinja"] >= 50 }
    },
    {
        "name": "5 Online Wins",
        "category": "Online",
        "title": "Ninja Has Awaken Online",
        "description": "Win 5 matches on Online",
        "image": "sleepy.png",
        "points": "15",
        "order": "14",
        "check": function (p) { return p["win_OnlineAll"] >= 5 || p["win_Online"] >= 5 }
    },
    {
        "name": "10 Online Wins",
        "category": "Online",
        "title": "Sparing Partner",
        "description": "Win 10 matches on Online",
        "image": "ninja-mask.png",
        "points": "15",
        "order": "15",
        "check": function (p) { return p["win_OnlineAll"] >= 10 || p["win_Online"] >= 10 }
    },
    {
        "name": "20 Online Wins",
        "category": "Online",
        "title": "Black Belt",
        "description": "Win 20 matches on Online",
        "image": "iron-mask.png",
        "points": "30",
        "order": "16",
        "check": function (p) { return p["win_OnlineAll"] >= 20 || p["win_Online"] >= 20 }
    },
    {
        "name": "30 Online Wins",
        "category": "Online",
        "title": "Online",
        "description": "Win 30 matches on Online",
        "image": "tear-tracks.png",
        "points": "40",
        "order": "17",
        "check": function (p) { return p["win_OnlineAll"] >= 30 || p["win_Online"] >= 30 }
    },
    {
        "name": "50 Online Wins",
        "category": "Online",
        "title": "Ninja Destroyer",
        "description": "Win 50 matches on Online",
        "image": "pummeled.png",
        "points": "60",
        "order": "18",
        "check": function (p) { return p["win_OnlineAll"] >= 50 || p["win_Online"] >= 50 }
    },
    {
        "name": "5 Wins",
        "category": "Overall",
        "title": "Reached Noob Status",
        "description": "Win 5 matches",
        "image": "mouse.png",
        "points": "15",
        "order": "19",
        "check": function (p) { return p["win"] >= 5 }
    },
    {
        "name": "10 Wins",
        "category": "Overall",
        "title": "Reached Noob+ Status",
        "description": "Win 10 matches",
        "image": "mouse.png",
        "points": "15",
        "order": "19",
        "check": function (p) { return p["win"] >= 10 }
    },
    {
        "name": "15 Wins",
        "category": "Overall",
        "title": "Reached Noob++ Status",
        "description": "Win 15 matches",
        "image": "mouse.png",
        "points": "15",
        "order": "19",
        "check": function (p) { return p["win"] >= 15 }
    },
    {
        "name": "20 Wins",
        "category": "Overall",
        "title": "Competent Cribber",
        "description": "Win 20 matches",
        "image": "octopus.png",
        "points": "15",
        "order": "19",
        "check": function (p) { return p["win"] >= 20 }
    },
    {
        "name": "25 Wins",
        "category": "Overall",
        "title": "Competent Cribber",
        "description": "Win 20 matches",
        "image": "octopus.png",
        "points": "15",
        "order": "19",
        "check": function (p) { return p["win"] >= 25 }
    },
    {
        "name": "30 Wins",
        "category": "Overall",
        "title": "Learning to Fly 2",
        "description": "Win 30 matches",
        "image": "owl.png",
        "points": "25",
        "order": "15",
        "check": function (p) { return p["win"] >= 30 }
    },
    {
        "name": "40 Wins",
        "category": "Overall",
        "title": "Learning to Fly 2",
        "description": "Win 40 matches",
        "image": "owl.png",
        "points": "30",
        "order": "15",
        "check": function (p) { return p["win"] >= 40 }
    },
    {
        "name": "50 Wins",
        "category": "Overall",
        "title": "Consistent Flyer",
        "description": "Win 50 matches",
        "image": "bird-twitter.png",
        "points": "35",
        "order": "21",
        "check": function (p) { return p["win"] >= 50 }
    },
    {
        "name": "60 Wins",
        "category": "Overall",
        "title": "Consistent Flyer 2",
        "description": "Win 60 matches",
        "image": "bird-twitter.png",
        "points": "40",
        "order": "21",
        "check": function (p) { return p["win"] >= 60 }
    },
    {
        "name": "70 Wins",
        "category": "Overall",
        "title": "Quiet Potential",
        "description": "Win 70 matches",
        "image": "white-cat.png",
        "points": "40",
        "order": "22",
        "check": function (p) { return p["win"] >= 70 }
    },
    {
        "name": "80 Wins",
        "category": "Overall",
        "title": "Quiet Potential 2",
        "description": "Win 80 matches",
        "image": "white-cat.png",
        "points": "60",
        "order": "22",
        "check": function (p) { return p["win"] >= 80 }
    },
    {
        "name": "90 Wins",
        "category": "Overall",
        "title": "Dangerous Foe",
        "description": "Win 90 matches",
        "image": "scorpion.png",
        "points": "65",
        "order": "23",
        "check": function (p) { return p["win"] >= 90 }
    },
    {
        "name": "100 Wins",
        "category": "Overall",
        "title": "Dangerous Foe 2",
        "description": "Win 100 matches",
        "image": "scorpion.png",
        "points": "70",
        "order": "23",
        "check": function (p) { return p["win"] >= 100 }
    },
    {
        "name": "125 Wins",
        "category": "Overall",
        "title": "Slippery Predator ",
        "description": "Win 125 matches",
        "image": "squid.png",
        "points": "70",
        "order": "24",
        "check": function (p) { return p["win"] >= 125 }
    },
    {
        "name": "150 Wins",
        "category": "Overall",
        "title": "Slippery Predator 2",
        "description": "Win 150 matches",
        "image": "squid.png",
        "points": "70",
        "order": "24",
        "check": function (p) { return p["win"] >= 150 }
    },
    {
        "name": "200 Wins",
        "category": "Overall",
        "title": "Power Player",
        "description": "Win 200 matches",
        "image": "hound.png",
        "points": "100",
        "order": "15",
        "check": function (p) { return p["win"] >= 200 }
    },
    {
        "name": "250 Wins",
        "category": "Overall",
        "title": "Quick and Formidable",
        "description": "Win 250 matches",
        "image": "lion.png",
        "points": "100",
        "order": "26",
        "check": function (p) { return p["win"] >= 250 }
    },
    {
        "name": "300 Wins",
        "category": "Overall",
        "title": "Unstoppable Force",
        "description": "Win 300 matches",
        "image": "croc-jaws.png",
        "points": "100",
        "order": "27",
        "check": function (p) { return p["win"] >= 300 }
    },
    {
        "name": "350 Wins",
        "category": "Overall",
        "title": "It's Dinomight!",
        "description": "Win 350 matches",
        "image": "dinosaur-rex.png",
        "points": "100",
        "order": "28",
        "check": function (p) { return p["win"] >= 350 }
    },
    {
        "name": "400 Wins",
        "category": "Overall",
        "title": "Soaring Above The Competition",
        "description": "Win 400 matches",
        "image": "eagle-emblem.png",
        "points": "100",
        "order": "29",
        "check": function (p) { return p["win"] >= 400 }
    },
    {
        "name": "450 Wins",
        "category": "Overall",
        "title": "King of Cards",
        "description": "Win 450 matches",
        "image": "king.png",
        "points": "125",
        "order": "30",
        "check": function (p) { return p["win"] >= 450 }
    }, {
        "name": "500 Wins",
        "category": "Overall",
        "title": "Cribbage Mind and Heart",
        "description": "Win 500 matches",
        "image": "anatomy.png",
        "points": "150",
        "order": "30",
        "check": function (p) { return p["win"] >= 500 }
    },
    {
        "name": "700 Wins",
        "category": "Overall",
        "title": "Cribbage Mind and Heart",
        "description": "Win 750 matches",
        "image": "anatomy.png",
        "points": "150",
        "order": "30",
        "check": function (p) { return p["win"] >= 750 }
    },
    {
        "name": "1000 Wins",
        "category": "Overall",
        "title": "Cribbage Mind and Heart",
        "description": "Win 1001 matches",
        "image": "anatomy.png",
        "points": "200",
        "order": "30",
        "check": function (p) { return p["win"] >= 1000 }
    },
    {
        "name": "Win Easy 5 times in a row",
        "category": "Easy",
        "title": "Dominator",
        "description": "Win Easy 5 times in a row",
        "image": "palm.png",
        "points": "15",
        "order": "31",
        "order": "30",
        "check": function (p) { return p["win_streak_Easy"] >= 5 }
    },
    {
        "name": "Win Medium 5 times in a row",
        "category": "Medium",
        "title": "Dominator",
        "description": "Win Medium 5 times in a row",
        "image": "palm.png",
        "points": "15",
        "order": "32",
        "check": function (p) { return p["win_streak_Medium"] >= 5 }
    },
    {
        "name": "Win Hard 5 times in a row",
        "category": "Hard",
        "title": "Dominator",
        "description": "Win Hard 5 times in a row",
        "image": "palm.png",
        "points": "35",
        "order": "33",
        "check": function (p) { return p["win_streak_Hard"] >= 5 }
    },
    {
        "name": "Win Crazy Ninja 5 times in a row",
        "category": "CrazyNinja",
        "title": "Dominator",
        "description": "Win Crazy Ninja 5 times in a row",
        "image": "palm.png",
        "points": "50",
        "order": "34",
        "check": function (p) { return p["win_streak_CrazyNinja"] >= 5 }
    },
    {
        "name": "Win Easy 7 times in a row",
        "category": "Easy",
        "title": "On Fire",
        "description": "Win Easy 7 times in a row",
        "image": "paw.png",
        "points": "15",
        "order": "35",
        "check": function (p) { return p["win_streak_Easy"] >= 7 }
    },
    {
        "name": "Win Medium 7 times in a row",
        "category": "Medium",
        "title": "On Fire",
        "description": "Win Medium 7 times in a row",
        "image": "paw.png",
        "points": "30",
        "order": "36",
        "check": function (p) { return p["win_streak_Medium"] >= 7 }
    },
    {
        "name": "Win Hard 7 times in a row",
        "category": "Hard",
        "title": "On Fire",
        "description": "Win Hard 7 times in a row",
        "image": "paw.png",
        "points": "50",
        "order": "37",
        "check": function (p) { return p["win_streak_Hard"] >= 7 }
    },
    {
        "name": "Win Crazy Ninja 7 times in a row",
        "category": "CrazyNinja",
        "title": "On Fire",
        "description": "Win Crazy Ninja 7 times in a row",
        "image": "paw.png",
        "points": "75",
        "order": "38",
        "check": function (p) { return p["win_streak_CrazyNinja"] >= 7 }
    },
    {
        "name": "Win Hard 10 times in a row",
        "category": "Hard",
        "title": "Overkill",
        "description": "Win Hard 10 times in a row",
        "image": "flaming-claw.png",
        "points": "100",
        "order": "39",
        "check": function (p) { return p["win_streak_Hard"] >= 10 }
    },
    {
        "name": "Win Crazy Ninja 10 times in a row",
        "category": "CrazyNinja",
        "title": "Overkill",
        "description": "Win Crazy Ninja 10 times in a row",
        "image": "flaming-claw.png",
        "points": "125",
        "order": "40",
        "check": function (p) { return p["win_streak_CrazyNinja"] >= 10 }
    },
    {
        "name": "Skunk 1 Games",
        "category": "Medium",
        "title": "That a Skunk",
        "description": "Skunked",
        "image": "goo-spurt.png",
        "points": "10",
        "order": "3",
        "check": function (p) { return p["skunked"] >= 1 }
    },
    {
        "name": "Skunk 2 Games",
        "category": "Medium",
        "title": "Skunked II",
        "description": "Skunk 2 games",
        "image": "goo-explosion.png",
        "points": "15",
        "order": "3",
        "check": function (p) { return p["skunked"] >= 2 }
    },
    {
        "name": "Skunk 5 Games",
        "category": "Medium",
        "title": "Skunked Time",
        "description": "Skunk 5 games",
        "image": "gooey-daemon.png",
        "points": "40",
        "order": "3",
        "check": function (p) { return p["skunked"] >= 5 }
    },
    {
        "name": "Skunk 10 Games",
        "category": "Medium",
        "title": "Skunked King",
        "description": "Skunk 10 games",
        "image": "gloop.png",
        "points": "80",
        "order": "3",
        "check": function (p) { return p["skunked"] >= 10 }
    },
    {
        "name": "Skunk 20 Games",
        "category": "Medium",
        "title": "Skunking Pro",
        "description": "Skunk 20 games",
        "image": "gift-trap.png",
        "points": "100",
        "order": "3",
        "check": function (p) { return p["skunked"] >= 20 }
    },
    {
        "name": "Skunk 40 Games",
        "category": "Hard",
        "title": "Skunking Master",
        "description": "Skunk 40 games",
        "image": "gluttony.png",
        "points": "100",
        "order": "3",
        "check": function (p) { return p["skunked"] >= 40 }
    },
    {
        "name": "Skunk 80 Games",
        "category": "Hard",
        "title": "Skunked Forever",
        "description": "Skunk 80 games",
        "image": "fountain.png",
        "points": "150",
        "order": "3",
        "check": function (p) { return p["skunked"] >= 80 }
    },
    {
        "name": "Hand Score 1",
        "category": "Medium",
        "title": "One Hand",
        "description": "Hand Score 1 on round 1",
        "image": "dinosaur-egg.png",
        "points": "10",
        "order": "3",
        "check": function (p) { return p["hand_Points_last"] === 1 && p["round_Number_last"] === 1 }
    },
    {
        "name": "Hand Score 4",
        "category": "Medium",
        "title": "Four Hand",
        "description": "Hand Score 4 on round 1",
        "image": "dinosaur-egg.png",
        "points": "10",
        "order": "3",
        "check": function (p) { return p["hand_Points_last"] === 4 && p["round_Number_last"] === 1 }
    },
    {
        "name": "Hand Score 6",
        "category": "Medium",
        "title": "Basic Hand",
        "description": "Hand Score 6 on round 1",
        "image": "dinosaur-egg.png",
        "points": "10",
        "order": "3",
        "check": function (p) { return p["hand_Points_last"] === 6 && p["round_Number_last"] === 1 }
    },
    {
        "name": "Hand Score 8",
        "category": "Medium",
        "title": "Hand Man",
        "description": "Hand Score 8 on round 1",
        "image": "dinosaur-egg.png",
        "points": "10",
        "order": "3",
        "check": function (p) { return p["hand_Points_last"] === 8 && p["round_Number_last"] === 1 }
    },
    {
        "name": "Hand Score 10",
        "category": "Medium",
        "title": "Fighting Hand",
        "description": "Hand Score 10",
        "image": "mailed-fist.png",
        "points": "15",
        "order": "3",
        "check": function (p) { return p["hand_Points_last"] === 10 }
    }, {
        "name": "Hand Score 12",
        "category": "Medium",
        "title": "Nice Hand",
        "description": "Hand Score 12 on round 1",
        "image": "diamond-hard.png",
        "points": "15",
        "order": "3",
        "check": function (p) { return p["hand_Points_last"] === 12 && p["round_Number_last"] === 1 }
    },
    {
        "name": "Hand Score 14",
        "category": "Medium",
        "title": "Hand Hand",
        "description": "Hand Score 14 on round 1",
        "image": "magic-palm.png",
        "points": "15",
        "order": "3",
        "check": function (p) { return p["hand_Points_last"] === 14 && p["round_Number_last"] === 1 }
    },
    {
        "name": "Hand Score 16",
        "category": "Medium",
        "title": "Sweet 16",
        "description": "Hand Score 16 on round 1",
        "image": "shining-heart.png",
        "points": "15",
        "order": "3",
        "check": function (p) { return p["hand_Points_last"] === 16 && p["round_Number_last"] === 1 }
    },
    {
        "name": "Hand Score 18",
        "category": "Medium",
        "title": "Power Hand",
        "description": "Hand Score 18",
        "image": "cut-diamond.png",
        "points": "30",
        "order": "3",
        "check": function (p) { return p["hand_Points_last"] === 18 }
    },
    {
        "name": "Hand Score 20",
        "category": "Medium",
        "title": "Power Hand 2",
        "description": "Hand Score 20",
        "image": "cut-diamond.png",
        "points": "40",
        "order": "3",
        "check": function (p) { return p["hand_Points_last"] === 20 }
    },
    {
        "name": "Hand Score 24",
        "category": "Medium",
        "title": "Ninja Hand",
        "description": "Hand Score 24",
        "image": "gem-pendant.png",
        "points": "125",
        "order": "3",
        "check": function (p) { return p["hand_Points_last"] >= 24 }
    },
    {
        "name": "Perfect-ish Hand Score 28",
        "category": "Impossible",
        "title": "Perfect-ish Hand",
        "description": "Perfect-ish Hand Score 28",
        "image": "gem-pendant.png",
        "points": "1000",
        "order": "3",
        "hidden": true,
        "check": function (p) { return p["hand_Points_max"] === 28 }
    },
    {
        "name": "Perfect Hand Score 29",
        "category": "Impossible",
        "title": "Perfect Hand",
        "description": "Perfect Hand Score 29",
        "image": "gem-pendant.png",
        "points": "1000",
        "order": "3",
        "hidden": true,
        "check": function (p) { return p["hand_Points_max"] === 29 }
    },
    {
        "name": "Pegging Score 4",
        "category": "Medium",
        "title": "Welcome to Pegging",
        "description": "Pegging Score 4 on round 1",
        "image": "gemini.png",
        "points": "15",
        "order": "3",
        "check": function (p) { return p["pegging_Points_last"] === 4 && p["round_Number_last"] === 1 }
    },
    {
        "name": "Pegging Score 6",
        "category": "Medium",
        "title": "Basic Pegging",
        "description": "Pegging Score 6 on round 1",
        "image": "axe-in-stump.png",
        "points": "15",
        "order": "3",
        "check": function (p) { return p["pegging_Points_last"] === 6 && p["round_Number_last"] === 1 }
    },
    {
        "name": "Pegging Score 7",
        "category": "Medium",
        "title": "Pegging trainee",
        "description": "Pegging Score 7 on round 1",
        "image": "axe-in-stump.png",
        "points": "15",
        "order": "3",
        "check": function (p) { return p["pegging_Points_last"] === 7 && p["round_Number_last"] === 1 }
    },
    {
        "name": "Pegging Score 8",
        "category": "Medium",
        "title": "Pegging time",
        "description": "Pegging Score 8 on round 1",
        "image": "battered-axe.png",
        "points": "15",
        "order": "3",
        "check": function (p) { return p["pegging_Points_last"] === 8 && p["round_Number_last"] === 1 }
    },
    {
        "name": "Pegging Score 10",
        "category": "Medium",
        "title": "Pegging Pro",
        "description": "Pegging Score 10",
        "image": "battered-axe.png",
        "points": "40",
        "order": "3",
        "check": function (p) { return p["pegging_Points_last"] === 10 }
    },
    {
        "name": "Pegging Score 12",
        "category": "Medium",
        "title": "Pegging Expert",
        "description": "Pegging Score 12",
        "image": "bat-blade.png",
        "points": "60",
        "order": "3",
        "check": function (p) { return p["pegging_Points_last"] === 12 }
    },
    {
        "name": "Pegging Score 14",
        "category": "Medium",
        "title": "Pegging Expert II",
        "description": "Pegging Score 14",
        "image": "gemini.png",
        "points": "70",
        "order": "3",
        "check": function (p) { return p["pegging_Points_last"] === 14 }
    },
    {
        "name": "Pegging Score 15",
        "category": "Medium",
        "title": "Pegging Master",
        "description": "Pegging Score 15",
        "image": "bat-blade.png",
        "points": "70",
        "order": "3",
        "check": function (p) { return p["pegging_Points_last"] === 15 }
    },
    {
        "name": "Crib Score 6",
        "category": "Medium",
        "title": "Baby Sleeps",
        "description": "Crib Score 6",
        "image": "lyre.png",
        "points": "10",
        "order": "3",
        "check": function (p) { return p["crib_Points_last"] === 6 }
    },
    {
        "name": "Crib Score 10",
        "category": "Medium",
        "title": "Crib Song",
        "description": "Crib Score 10",
        "image": "love-song.png",
        "points": "10",
        "order": "3",
        "check": function (p) { return p["crib_Points_last"] === 10 }
    },
    {
        "name": "Crib Score 14",
        "category": "Medium",
        "title": "Fighting Crib",
        "description": "Crib Score 14",
        "image": "magic-swirl.png",
        "points": "15",
        "order": "3",
        "check": function (p) { return p["crib_Points_last"] === 14 }
    },
    {
        "name": "Crib Score 16",
        "category": "Medium",
        "title": "Sweet 16 Crib",
        "description": "Crib Score 16",
        "image": "techno-heart.png",
        "points": "15",
        "order": "3",
        "check": function (p) { return p["crib_Points_last"] === 16 }
    },
    {
        "name": "Crib Score 18",
        "category": "Medium",
        "title": "Crib Crib",
        "description": "Crib Score 18",
        "image": "locked-chest.png",
        "points": "40",
        "order": "3",
        "check": function (p) { return p["crib_Points_last"] === 18 }
    },
    {
        "name": "Crib Score 21",
        "category": "Medium",
        "title": "Power Crib",
        "description": "Crib Score 21",
        "image": "salt-shaker.png",
        "points": "70",
        "order": "3",
        "check": function (p) { return p["crib_Points_last"] === 21 }
    },
    {
        "name": "Crib Score 24",
        "category": "Medium",
        "title": "Ninja Crib",
        "description": "Crib Score 24",
        "image": "sunrise.png",
        "points": "150",
        "order": "3",
        "check": function (p) { return p["crib_Points_last"] >= 24 }
    },
    {
        "name": "Round Score 10",
        "category": "Medium",
        "title": "Baby Steps",
        "description": "Round Score 10",
        "image": "tooth.png",
        "points": "15",
        "order": "3",
        "check": function (p) { return p["round_Points_last"] === 10 }
    },
    {
        "name": "Round Score 14",
        "category": "Medium",
        "title": "Take Flight",
        "description": "Round Score 14",
        "image": "two-feathers.png",
        "points": "15",
        "order": "3",
        "check": function (p) { return p["round_Points_last"] === 14 }
    },
    {
        "name": "Round Score 20",
        "category": "Medium",
        "title": "Round Juice",
        "description": "Round Score 20",
        "image": "vile-fluid.png",
        "points": "15",
        "order": "3",
        "check": function (p) { return p["round_Points_last"] === 20 }
    },
    {
        "name": "Round Score 22",
        "category": "Medium",
        "title": "Round and Round",
        "description": "Round Score 22",
        "image": "whirlwind.png",
        "points": "15",
        "order": "3",
        "check": function (p) { return p["round_Points_last"] === 22 }
    },
    {
        "name": "Round Score 25",
        "category": "Medium",
        "title": "Round and Round",
        "description": "Round Score 25",
        "image": "whirlwind.png",
        "points": "15",
        "order": "3",
        "check": function (p) { return p["round_Points_last"] === 25 }
    },
    {
        "name": "Round Score 28",
        "category": "Medium",
        "title": "Round and Round",
        "description": "Round Score 28",
        "image": "whirlwind.png",
        "points": "40",
        "order": "3",
        "check": function (p) { return p["round_Points_last"] === 28 }
    },
    {
        "name": "Round Score 30",
        "category": "Medium",
        "title": "Tall Round",
        "description": "Round Score 30",
        "image": "white-tower.png",
        "points": "65",
        "order": "3",
        "check": function (p) { return p["round_Points_max"] >= 30 }
    },
    {
        "name": "Round Score 32",
        "category": "Medium",
        "title": "Tall Round",
        "description": "Round Score 32",
        "image": "white-tower.png",
        "points": "65",
        "order": "3",
        "check": function (p) { return p["round_Points_max"] >= 32 }
    },
    {
        "name": "Round Score 34",
        "category": "Medium",
        "title": "Fire Ninja Round",
        "description": "Round Score 34",
        "image": "wildfires.png",
        "points": "70",
        "order": "3",
        "check": function (p) { return p["round_Points_max"] >= 34 }
    },
    {
        "name": "Round Score 36",
        "category": "Medium",
        "title": "Fire Ninja Round",
        "description": "Round Score 36",
        "image": "wildfires.png",
        "points": "100",
        "order": "3",
        "check": function (p) { return p["round_Points_max"] >= 36 }
    },
    {
        "name": "Round Score 38",
        "category": "Medium",
        "title": "Super Fire Ninja Round",
        "description": "Round Score 38",
        "image": "wildfires.png",
        "points": "125",
        "order": "3",
        "check": function (p) { return p["round_Points_max"] >= 38 }
    },
    {
        "name": "Round Score 40",
        "category": "Medium",
        "title": "Super Duper Fire Ninja Round",
        "description": "Round Score 40+",
        "image": "wildfires.png",
        "points": "200",
        "order": "3",
        "check": function (p) { return p["round_Points_max"] >= 40 }
    },
    {
        "name": "Invite 7 Friends",
        "category": "Easy",
        "title": "Funner with Friends",
        "description": "Invite 7 Friends",
        "image": "backup.png",
        "points": "200",
        "order": "1",
        "check": function (p) { return (p["friends"] ? p["friends"].length >= 7 : false) }
    },
    {
        "name": "Watch 5 Reward Ads",
        "category": "Easy",
        "title": "Pay the Developer",
        "description": "Watch 5 Reward Ads",
        "image": "backup.png",
        "points": "100",
        "order": "1",
        "check": function (p) { return p["rewardAdCount"] >= 5 || p["fullVersion"] || p["removeAds"] }
    },
    {
        "name": "Watch 15 Reward Ads",
        "category": "Easy",
        "title": "Pay the Developers",
        "description": "Watch 15 Reward Ads",
        "image": "backup.png",
        "points": "150",
        "order": "1",
        "check": function (p) { return p["rewardAdCount"] >= 15 || p["fullVersion"] || p["removeAds"] }
    },
    {
        "name": "titleTapped10",
        "category": "Easy",
        "title": "Title Tapper",
        "description": "Tap the title 10 times",
        "image": "wildfires.png",
        "points": "50",
        "item": "CribbageBoardGuitar",
        "order": "1",
        "check": function (p) { return p["titleTapped"] >= 10 }
    }, {
        "name": "titleTapped20",
        "category": "Easy",
        "title": "Title Tapper More",
        "description": "Tap the title 20 times",
        "image": "wildfires.png",
        "points": "50",
        "order": "1",
        "isHidden": "true",
        "check": function (p) { return p["titleTapped"] >= 20 }
    }
    , {
        "name": "titleTapped50",
        "category": "Medium",
        "title": "Title Tapper Extreme",
        "description": "You won the title tapping contest by tapping 50 times!",
        "image": "wildfires.png",
        "points": "50",
        "order": "1",
        "isHidden": "true",
        "check": function (p) { return p["titleTapped"] >= 50 }
    },
    {
        "name": "titleTapped100",
        "category": "Hard",
        "title": "Title Tapper Maximum",
        "description": "There are no more Title Tapper achievements after this",
        "image": "wildfires.png",
        "points": "50",
        "order": "1",
        "isHidden": "true",
        "check": function (p) { return p["titleTapped"] >= 100 }
    },
    {
        "name": "titleTapped200",
        "category": "Hard",
        "title": "Title Tapper Maximum",
        "description": "Fine, there was one more, but this is the last one for sure",
        "image": "wildfires.png",
        "points": "60",
        "order": "1",
        "isHidden": "true",
        "check": function (p) { return p["titleTapped"] >= 200 }
    },
    {
        "name": "titleTapped300",
        "category": "Hard",
        "title": "Title Tapper Crazy",
        "description": "This is the absolute last one, promise!",
        "image": "wildfires.png",
        "points": "70",
        "order": "1",
        "isHidden": "true",
        "check": function (p) { return p["titleTapped"] >= 300 }
    },
    {
        "name": "titleTapped400",
        "category": "Hard",
        "title": "Title Tapper INsaNE",
        "description": "This is not a clicker game, stop it!",
        "image": "wildfires.png",
        "points": "80",
        "order": "1",
        "isHidden": "true",
        "check": function (p) { return p["titleTapped"] >= 400 }
    },
    {
        "name": "titleTapped500",
        "category": "Hard",
        "title": "Title Tapper ULTRA INsaNE",
        "description": "Seriously, stop it!",
        "image": "wildfires.png",
        "points": "90",
        "order": "1",
        "isHidden": "true",
        "check": function (p) { return p["titleTapped"] >= 500 }
    },
    {
        "name": "titleTapped600",
        "category": "Hard",
        "title": "Title Tapper EXTREME INsaNE",
        "description": "You may want to find a real clicker game",
        "image": "wildfires.png",
        "points": "100",
        "order": "1",
        "isHidden": "true",
        "check": function (p) { return p["titleTapped"] >= 600 }
    },
    {
        "name": "playAYear1",
        "category": "Medium",
        "title": "Play a Year",
        "description": "Play the game for a year",
        "image": "sands-of-time.png",
        "points": "250",
        "order": "1",
        "check": function (p) { return Date.now() - p["first_open"] > ((1000 * 60 * 60 * 24) * (365 * 1)) }
    },
    {
        "name": "playAYear2",
        "category": "Medium",
        "title": "Play 2 Years",
        "description": "Play the game for 2 years",
        "image": "sands-of-time.png",
        "points": "300",
        "order": "1",
        "hidden": true,
        "check": function (p) { return Date.now() - p["first_open"] > ((1000 * 60 * 60 * 24) * (365 * 2)) }
    },
    {
        "name": "playAYear3",
        "category": "Hard",
        "title": "Play 3 Years",
        "description": "Play the game for 3 years",
        "image": "sands-of-time.png",
        "points": "350",
        "order": "1",
        "hidden": true,
        "check": function (p) { return Date.now() - p["first_open"] > ((1000 * 60 * 60 * 24) * (365 * 3)) }
    },
    {
        "name": "playAYear4",
        "category": "Hard",
        "title": "Play 4 Years",
        "description": "Play the game for 4 years",
        "image": "sands-of-time.png",
        "points": "400",
        "order": "1",
        "hidden": true,
        "check": function (p) { return Date.now() - p["first_open"] > ((1000 * 60 * 60 * 24) * (365 * 4)) }
    }
];